import utils from "./utils";

export default class Auth {
  constructor(api) {
    this.api = api;
  }

  login(data, onSuccess, onError) {
    return this.api.http_fibercloud
      .post("v1/auth", data)
      .then(resp => {
        onSuccess(resp);
      })
      .catch(error => {
        onError(error);
      });
  }

  logout(onSuccess, onError) {
    return this.api.http_fibercloud
      .post("v3/session/end")
      .then(resp => {
        onSuccess(resp);
      })
      .catch(error => {
        onError(error);
      });
  }

  getCredentials(onSuccess, onError) {
    return this.api.http_fibercloud
      .get("v1/mycredentials")
      .then(resp => {
        onSuccess(resp);
      })
      .catch(error => {
        onError(error);
      });
  }

  getDetails(onSuccess, onError) {
    return this.api.http_fibercloud
      .get("v1/mydetails")
      .then(resp => {
        onSuccess(resp);
      })
      .catch(error => {
        onError(error);
      });
  }

  workspacesByUserAndCompany(onSuccess, onError) {
    return this.api.http_fibercloud
      .get("v1/workspacesbyuserandcompany", {
        headers: {
          companyuuid: utils.getCompanyUUID()
        }
      })
      .then(resp => {
        onSuccess(resp);
      })
      .catch(error => {
        onError(error);
      });
  }

  rolesByUserAndCompany(onSuccess, onError) {
    return this.api.http_fibercloud
      .get("v1/rolesbyuserandcompany", {
        headers: {
          companyuuid: utils.getCompanyUUID()
        }
      })
      .then(resp => {
        onSuccess(resp);
      })
      .catch(error => {
        onError(error);
      });
  }
}



// WEBPACK FOOTER //
// ./src/api/auth.js